/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Chart from "../ApexChartSafe";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { Clock } from "react-bootstrap-icons";

import moment from "moment";
import momenttz from "moment-timezone";
// import { from, to } from "../intervals";

export default function WindChart({ wind, options, settings }) {
  const [RecentValue, setRecentValue] = useState({ value: 0, time: "" });
  const [RecentGustValue, setRecentGustValue] = useState(0);
  const [Average, setAverage] = useState(0);
  const windData = [];
  const gust = [];
  const windLimit1 = [
    { x: parseInt(options.xaxis.min, 10), y: 5 },
    { x: parseInt(options.xaxis.max, 10), y: 5 },
  ];
  const windLimit2 = [
    { x: parseInt(options.xaxis.min, 10), y: 20 },
    { x: parseInt(options.xaxis.max, 10), y: 20 },
  ];

  if (wind.data !== undefined) {
    wind.data.forEach((item) => {
      windData.push({ x: parseInt(item.readingDate, 10), y: item.wind });
      gust.push({ x: parseInt(item.readingDate, 10), y: item.gust });
    });
  }
  const [apex, setApex] = useState({
    options: {
      ...options,
      chart: {
        ...options.chart,
      },
      legend: {
        show: false,
      },
      markers: {
        size: [0, 0, 0, 0, 0],
      },
      fill: {
        type: "solid",
        pattern: {
          style: "squares",
        },
      },
      stroke: {
        ...options.stroke,
        dashArray: [0, 0, 5, 5],
      },
      colors: ["#F6FF00", "#79D2DE", "#fb8500", "#d00000"],
      xaxis: {
        ...options.xaxis,
        tickAmount: 16,
      },
      yaxis: [
        {
          ...options.yaxis[0],
          max: 45,
          min: 0,
          title: {
            text: "Wind",
            style: {
              fontSize: "14px",
            },
          },
        },
      ],
    },
    series: [
      {
        data: [],
      },
    ],
  });

  let indicator;

  const isStaleData = (readingDate, stalePeriod, tag = '') => {
    const lastReading = moment.unix(readingDate).tz(settings.station_timezone).format("DD/MM/YY HH:mm:ss a").toString();
    const currentTime = moment(new Date()).tz(settings.station_timezone).format("DD/MM/YY HH:mm:ss a").toString();
    const readingInterval = moment.duration(
      moment(currentTime, "DD/MM/YY HH:mm:ss a")
        .diff(moment(lastReading, "DD/MM/YY HH:mm:ss a"))
    ).asMinutes();

    return (Math.floor(readingInterval) > stalePeriod);
  }

  const clockIndicator = (lastUpdated) => {
    return (
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={
          <Tooltip id="button-tooltip__cloud-1">
            Last updated {moment.unix(lastUpdated).tz(settings.station_timezone).format("DD-MMM HH:mm:ssa")}
          </Tooltip>
        }
      >
        <Clock className="clock__icon" />
      </OverlayTrigger>
    );
  }

  if (isStaleData(RecentValue.lastReading, 15)) {
    indicator = (
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={
          <Tooltip id="button-tooltip__wind">
            Last updated {RecentValue.time}
          </Tooltip>
        }
      >
        {clockIndicator(RecentValue.lastReading)}
      </OverlayTrigger>
    );
  } else {
    if (parseInt(RecentValue.value, 10) >= 0 && RecentValue.value <= 5) {
      indicator = (
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 400 }}
          overlay={
            <Tooltip id="button-tooltip__wind">
              Last updated {RecentValue.time}
            </Tooltip>
          }
        >
          <status-indicator
            active
            positive
            pulse
            style={{ margin: "0 10px" }}
          />
        </OverlayTrigger>
      );
    }
    if (
      parseInt(RecentValue.value, 10) >= 5 &&
      parseInt(RecentValue.value, 10) <= 20
    ) {
      indicator = (
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 400 }}
          overlay={
            <Tooltip id="button-tooltip__wind">
              Last updated {RecentValue.time}
            </Tooltip>
          }
        >
          <status-indicator active pulse style={{ margin: "0 10px" }} />
        </OverlayTrigger>
      );
    }
    if (parseInt(RecentValue.value, 10) > 20) {
      indicator = (
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 400 }}
          overlay={
            <Tooltip id="button-tooltip__wind">
              Last updated {RecentValue.time}
            </Tooltip>
          }
        >
          <status-indicator
            active
            negative
            pulse
            style={{ margin: "0 10px" }}
          />
        </OverlayTrigger>
      );
    }
  }

  useEffect(() => {
    setApex({
      ...apex,
      options: {
        ...apex.options,
        xaxis: {
          ...apex.options.xaxis,
          min: options.xaxis.min,
          max: options.xaxis.max,
        },
      },
      series: [
        {
          name: "Gust",
          type: "line",
          data: gust,
        },
        {
          name: "Wind",
          type: "line",
          data: windData,
        },
        {
          name: "wind Limit",
          type: "line",
          data: windLimit1,
        },
        {
          name: "wind Limit",
          type: "line",
          data: windLimit2,
        },
      ],
    });

    setRecentValue(
      windData[0] === undefined
        ? { value: "", time: "", lastReading: "" }
        : {
          value: windData[windData.length - 1].y,
          time: momenttz(new Date(windData[windData.length - 1].x * 1000))
            .tz(`${settings.station_timezone}`)
            .format("HH:mm"),
          lastReading: windData[windData.length - 1].x
        }
    );
    setRecentGustValue(gust[0] === undefined ? "" : gust[gust.length - 1].y);
    setAverage(
      windData[0] === undefined
        ? ""
        : windData.reduce((a, b) => a + parseInt(b.y, 10), 0) / windData.length
    );
  }, [wind]);
  return (
    <div className="p-0 full-height custom-card">
      <div className="recent-value">
        <h6 className="custom-card__title">
          <span>
            average:{" "}
            <span className="value">
              {Average !== "" ? parseFloat(Average).toFixed(1) : " _ "}
            </span>
            km/h gust:{" "}
            <span className="value">
              {RecentGustValue !== ""
                ? parseFloat(RecentGustValue).toFixed(1)
                : " _ "}
            </span>
            km/h
          </span>
        </h6>
      </div>
      <div className="full-height">
        <Chart
          id="wind-chart"
          options={apex.options}
          series={apex.series}
          type="line"
          width="95%"
          height="250"
        />
      </div>
    </div>
  );
}

WindChart.propTypes = {
  wind: PropTypes.shape({ data: PropTypes.shape([]) }).isRequired,
  options: PropTypes.shape({
    chart: PropTypes.shape({}),
    stroke: PropTypes.shape({}),
    length: PropTypes.shape({}),
    yaxis: PropTypes.shape({}),
    xaxis: PropTypes.shape({ labels: PropTypes.shape({}) }),
  }).isRequired,
  settings: PropTypes.shape({
    station_timezone: PropTypes.string,
  }).isRequired,
};
